import React, { useCallback } from 'react';
import { useColorMode } from 'theme-ui';
import { IconButton } from '@theme-ui/components';
import { Sun } from '@carbonplan/icons';

export const Dimmer = (props: any): JSX.Element => {
  const [colorMode, setColorMode] = useColorMode();

  const toggle = useCallback(() => {
    setColorMode(colorMode === 'light' ? 'dark' : 'light');
  }, [colorMode]);

  return (
    <IconButton
      {...props}
      aria-label="toggle dark mode"
      onClick={toggle}
      role="checkbox"
      m={1}
    >
      <Sun
        sx={{
          strokeWidth: '1.75',
        }}
      />
    </IconButton>
  );
};
